/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { cssParser } from '../utils/parser'

const Bridge = ({ css, onComplete }) => {

    const isLevelComplete = () => {
        return document.getElementById("logs-container")?.style?.flexDirection === "row"
    }

    useEffect(() => {
        if (isLevelComplete()) {
            onComplete();
        }
    }, [css])

    return (
        <div id="bridge">
            <img id="van" src="/images/van.png" alt="van" style={{ animationPlayState: isLevelComplete() ? "running" : "paused" }} />
            <p id="level-3-id" style={{
                "position": "absolute",
                "top": "50px",
                "left": "100px",
                "color": "white",
                "fontWeight": "bold",
                "zIndex": "5"
            }}>#wooden-blocks-container</p>
            <div id="logs-container" style={cssParser(css)}>
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
                <div id="log" />
            </div>
        </div>
    )
}

export default Bridge